
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';


import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';

import Admin from './pages/Admin';
import Home from './pages/Home';
import ListUsers from './pages/ListUsers';
import Dashboard from './pages/Dashboard';
import { useEffect, useState } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useSelector } from 'react-redux';
import NotFound from './components/NotFound/NotFound';
import AddReport from './pages/AddReport';
import CheckVanFletId from './pages/ChekVanFletId';

function App() {
  
  const user = useSelector(state=> state.us.current)
 
  

  useEffect(() => {
    Aos.init({ duration: 1000 });

  
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        {/* {user && <Route path="/admin/list-users" element={<ListUsers />} />} */}
        <Route path="/admin" element={<Admin />} />
        <Route path="/dashboard" element={<Dashboard />} />

        <Route path="/add-report" element={<AddReport />} />

        <Route path="/admin/list-users" element={<ListUsers />} />

        <Route path="/clients/checkvanfletid/:id" element={<CheckVanFletId/>}></Route>

         <Route path="*" element={< NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
